import { colors } from './tokens';

/** Brand-gradient text, used by page and welcome headings. */
export const gradientText = {
  background: colors.brandGradient,
  WebkitBackgroundClip: 'text',
  backgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  color: 'transparent',
  display: 'inline-block',
} as const;
